import isMicrosoft from "./isMicrosoft";
import isDeloitte from "./isDeloitte";

const getDefaultLabel = (organizationName: string) => {
  if (isMicrosoft(organizationName)) {
    return "Profession";
  }

  if (isDeloitte(organizationName)) {
    return "Business";
  }

  return "Department";
};

const getDefaultPluralLabel = (organizationName: string) => {
  if (isDeloitte(organizationName)) {
    return `${getDefaultLabel(organizationName)}es`;
  }
  return `${getDefaultLabel(organizationName)}s`;
};

const getDepartmentLabel = (organizationName: string, singular = true, lowercase = false) => {
  let value = getDefaultPluralLabel(organizationName);

  if (singular) {
    value = getDefaultLabel(organizationName);
  }

  if (lowercase) {
    return value.toLowerCase();
  }

  return value;
};

export default getDepartmentLabel;
